import { SEO_TITLE_USERS_MANUAL_PHONE_VERIFICATION } from 'mk/autogenerated/translations/ManualPhoneVerificationPage.5e7a64d33ee5631e7636e2dfdc1bf5e9'
import { isAuthenticated } from 'mk/bazaar/common/userUtils';
import ManualPhoneVerification from 'mk2/apps/users/containers/ManualPhoneVerification/ManualPhoneVerification';
import { phoneVerificationFetchTrigger } from 'mk2/apps/users/containers/ManualPhoneVerification/ManualPhoneVerification.actions';
import phoneVerificationsReducer from 'mk2/apps/users/containers/ManualPhoneVerification/ManualPhoneVerification.reducers';
import phoneVerificationsSaga from 'mk2/apps/users/containers/ManualPhoneVerification/ManualPhoneVerification.sagas';
import { getUsersManualPhoneVerificationState } from 'mk2/apps/users/containers/ManualPhoneVerification/ManualPhoneVerification.selectors';
import { AppName } from 'mk2/containers/Application/Application';
import { phoneVerificationModalShow } from 'mk2/containers/PhoneVerificationModal/PhoneVerificationModal.actions';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import Page from 'mk2/pages/Page';
import { AppState, getRequestPermissions, getRequestUser } from 'mk2/reducers';
import { LoadingState } from 'mk2/reducers/loadingState';
import { HeaderMenuItem, MenuSelection, UserEntity } from 'mk2/schemas';
import { Store } from 'mk2/store/configureStore';
import React from 'react';
import { MapStateToPropsParam } from 'react-redux';
import { RouteComponentProps } from 'react-router';

interface OwnProps {}
interface StateProps {
    alreadyVerified: boolean;
    requestUser: UserEntity;
    requestUserPermissions: string[];
    loadingState: LoadingState;
}

interface DispatchProps {
    onLoad(userId: number);
    onOpenVerifyModal();
}

type RouteProps = RouteComponentProps<{}>;

export type Props = OwnProps & StateProps & DispatchProps & RouteProps;

export default class ManualPhoneVerificationPage extends Page<OwnProps & RouteProps, StateProps, DispatchProps> {

    public mapStateToProps(): MapStateToPropsParam<StateProps, OwnProps & RouteProps, AppState> {
        return (state: AppState, ownProps: OwnProps & RouteProps): StateProps => {
            const requestUser = getRequestUser(state);
            const verificationState = getUsersManualPhoneVerificationState(state);

            return {
                alreadyVerified: isAuthenticated(requestUser) ? verificationState.alreadyVerified : null,
                requestUser: getRequestUser(state),
                requestUserPermissions: getRequestPermissions(state),
                loadingState: isAuthenticated(requestUser) ? verificationState.loadingState : LoadingState.SUCCESS,
            };
        };
    }

    public mapDispatchToProps(): MapDispatchToPropsObject<DispatchProps> {
        return {
            onLoad: phoneVerificationFetchTrigger,
            onOpenVerifyModal: () => phoneVerificationModalShow('manual'),
        };
    }

    public getMetaTitle(props: Props): string {
        return SEO_TITLE_USERS_MANUAL_PHONE_VERIFICATION;
    }

    public render(props: Props): false | JSX.Element {
        return (
            <ManualPhoneVerification {...props} />
        );
    }

    public hasHeaderBackButton(props: Props): boolean {
        return false;
    }

    public getHeaderMenuSelection(app: AppName, props: Props): MenuSelection {
        return {
            activeSection: 'userbar',
            activeItem: HeaderMenuItem.UserPhoneVerification,
        };
    }

    public registerInStore(store: Store<AppState>) {
        store.injectReducer('containers.users.manualPhoneVerification', phoneVerificationsReducer);
        store.injectSaga('containers.users.manualPhoneVerification', phoneVerificationsSaga);
    }
}
